import * as React from 'react';
import { Modal, ModalProps } from 'semantic-ui-react';

function listener(evento: FocusEvent) {
    const modal = document.getElementById('modal-que-debe-enfocarse');
    if (modal && !modal.contains(evento.target as Node)) {
        const elemento = document.getElementById('enfocar-dentro-del-modal');
        if (elemento) {
            evento.stopPropagation();
            elemento.focus();
        }
    }
}

interface Props extends ModalProps {
    id?: never;
}

const ModalEnfocable: React.FunctionComponent<Props> = props => {
    const { id: _, onMount, onUnmount, children, ...resto } = props;

    return (
        <Modal
            id='modal-que-debe-enfocarse'
            size='tiny'
            dimmer='blurring'
            onMount={(n, p) => {
                document.addEventListener('focus', listener, true);
                if (onMount) {
                    onMount(n, p);
                }
            }}
            onUnmount={(n, p) => {
                document.removeEventListener('focus', listener, true);
                if (onUnmount) {
                    onUnmount(n, p);
                }
            }}
            {...resto}
        >
            <span id='enfocar-dentro-del-modal' tabIndex={-1} />
            {children}
        </Modal>
    );
};

export default ModalEnfocable;



// WEBPACK FOOTER //
// ./src/componentes/semantic-ui-extended/ModalEnfocable/index.tsx